import React from 'react';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { ReactFCV } from '@types';

import { useCartPageContext } from '../../context';

import { DiscountList } from './components';
import { DISCOUNT_TYPE_CUSTOMER_LOYALTY } from './constants';

export const CartDiscountsWrapper: ReactFCV = () => {
  const {
    state: { discounts, products },
  } = useCartPageContext();

  const {
    applicationSettings: { secondaryCurrency },
  } = useApplicationRuntimeContext();

  const isDualPriceLayout = Boolean(secondaryCurrency);

  return (
    <DiscountList
      discounts={discounts}
      products={products}
      whiteList={[DISCOUNT_TYPE_CUSTOMER_LOYALTY]}
      isDualPriceLayout={isDualPriceLayout}
    />
  );
};
